import React from 'react';
import {
  makeStyles, Typography,
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  medium: {
    fontWeight: '500',
  },
}));

const HeadingMD = (props) => {
  const { title } = props;
  const classes = useStyles();

  return (
    <>
      <Typography variant="h4" className={classes.medium}>
        {title}
      </Typography>
    </>
  );
};

export default HeadingMD;
